
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-10092 -2438 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Symbol 274 – 87","transform":"translate(-10695 -3474)"}},[_c('circle',{attrs:{"cx":"8.5","cy":"8.5","r":"8.5","data-name":"Ellipse 984","transform":"translate(603 1036)","fill":"#f44336"}}),_c('path',{attrs:{"d":"M610.748 1045.703a.794.794 0 0 0 .677.677.684.684 0 0 0 .6-.3 2.391 2.391 0 0 0 .226-.677c.075-.9.376-3.761.451-4.438a3.625 3.625 0 0 0 0-.9 1.2 1.2 0 0 0-.677-.9 1.464 1.464 0 0 0-1.128 0 1.478 1.478 0 0 0-.676 1.273 5.633 5.633 0 0 0 .076.743c.055.3.3 3.018.375 4.146.038.169.076.376.076.376zm.752 1.655a1.242 1.242 0 1 0-.075 2.482 1.224 1.224 0 0 0 1.279-1.279 1.145 1.145 0 0 0-1.204-1.203z","data-name":"Path 19938","fill":"#fff"}})])])
          )
        }
      }
    